import { useLocale } from '../../context';

function IconGoogle() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
    </svg>
  );
}

function IconTelegram() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="12" fill="#2AABEE" />
      <path
        fill="#fff"
        d="M17.6 7.25c.18-.08.38 0 .45.18.04.1.04.2 0 .3l-2.05 9.55c-.08.35-.3.43-.62.27l-3.05-2.25-1.47 1.42c-.16.16-.3.3-.61.3l.22-3.15 5.72-5.17c.25-.22.05-.35-.2-.13l-7.07 4.45-2.87-.9c-.62-.2-.63-.62.13-.92l11.42-4.35z"
      />
    </svg>
  );
}

function IconX() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.227-8.451L1.254 2.25H8.08l4.253 5.622L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z"
      />
    </svg>
  );
}

const PROVIDERS = [
  { id: 'telegram', label: 'Telegram', Icon: IconTelegram },
  { id: 'x', label: 'X', Icon: IconX },
  { id: 'google', label: 'Google', Icon: IconGoogle },
];

export default function AuthSocialProviders({ providers, titleKey = 'auth.register.orSignUpWith' }) {
  const _locale = useLocale();
  const tr = _locale.t;
  const enabled = PROVIDERS.filter((p) => providers?.[p.id]?.enabled);

  if (!enabled.length) return null;

  return (
    <div className="auth-providers">
      <div className="auth-providers__title">{tr(titleKey)}</div>
      <div className="auth-providers__list">
        {enabled.map(({ id, label, Icon }) => {
          const href = String(providers?.[id]?.url || `/api/auth/oauth/${id}/start`).trim();
          const className = `auth-providers__button auth-providers__button--${id}`;
          if (!href) {
            return (
              <button
                key={id}
                type="button"
                className={className}
                disabled
                title={tr('auth.register.socialNotConfigured')}
              >
                <span className="auth-providers__icon"><Icon /></span>
                <span className="auth-providers__label">{label}</span>
              </button>
            );
          }
          return (
            <a
              key={id}
              className={className}
              href={href}
              rel="noopener noreferrer"
              data-provider={id}
            >
              <span className="auth-providers__icon"><Icon /></span>
              <span className="auth-providers__label">{label}</span>
            </a>
          );
        })}
      </div>
    </div>
  );
}
